import ReservationMatchOptionItem from "@components/ReservationMatchOptionItem";
import type { ReservationMatchOptionItem_ReservationMatchOptionFragment } from "@components/ReservationMatchOptionItem/__generated__/fragments";
import { ReservationFormRow } from "@components/pages/shops/[uuid]/request_reservation/ReservationFormRow";
import type { FC } from "react";

type Props = {
  matchOptions: ReservationMatchOptionItem_ReservationMatchOptionFragment[];
};

export const ReservationFormMatchOptionRow: FC<Props> = ({ matchOptions }) => {
  return (
    <ReservationFormRow title="試合観戦">
      {matchOptions.map((matchOption) => (
        <ReservationMatchOptionItem
          key={matchOption.match?.id ?? -1}
          matchOption={matchOption}
        />
      ))}
    </ReservationFormRow>
  );
};
